import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FuStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';

@Component({
    selector: 'app-fu-list-status-indicator',
    templateUrl: './fu-list-status-indicator.component.html',
    styleUrls: ['./fu-list-status-indicator.component.scss'],
    standalone: false,
})
export class FuListStatusIndicatorComponent {
    @Input() isReceivingData: boolean;
    @Input() index: number;
    @Input() fuStatus: FuStatus;
    @Output() onSelectFu: EventEmitter<FuStatus> = new EventEmitter<FuStatus>();

    constructor(private systemStatusService: SystemStatusService) {}

    hasAlarms(): boolean {
        if (!this.isReceivingData) return false;
        return this.systemStatusService.getAlarmCounts(this.fuStatus) > 0;
    }

    selectFU() {
        this.onSelectFu.emit(this.fuStatus);
    }
}
